import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import NProgress from 'vue-nprogress'
import VueMoment from 'vue-moment'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VueCookies from 'vue-cookies'
import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css'
import VueNativeSock from 'vue-native-websocket'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import store from '@/store/index'
import router from '@/router/index'
import ComponentsLoader from '@/components/ui/loader'

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

if (process.env.VUE_APP_SENTRY_ENV !== 'dev') {
  Sentry.init({
    Vue,
    dsn: 'https://ee5923796f0f4a80a4e1dca485ecde2a@digital-sentry.ddns.net/9',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'gazprom-classes', /^\//]
      })
    ],
    release: process.env.VUE_APP_RELEASE,
    environment: process.env.VUE_APP_SENTRY_ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACE_RATE)
  })
}

const moment = require('moment')
require('moment/locale/ru')

Vue.use(BootstrapVue)
Vue.use(NProgress)
Vue.use(CKEditor)
Vue.use(VueCookies)
Vue.use(VueKatex)
const nprogress = new NProgress({ parent: '.nprogress-container' })
const App = () => import('./App.vue')

nprogress.configure({
  showSpinner: false
})

Vue.use(VueMoment, {
  moment
})

ComponentsLoader.load(Vue)
store.dispatch('initialize').then(() => {
  new Vue({
    router,
    store,
    template: '<App/>',
    components: {
      App
    },
    render: (h) => h(App)
  }).$mount('#app')
})

Vue.use(VueNativeSock, 'ws://localhost:70/api/ws/', {
  connectManually: true,
  store,
  format: 'json',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000 // (Number) how long to initially wait before attempting a new (1000)
})
